<template>
  <div class="filedetails">
    <div class="filedeta_centers">
      <div class="inner">
        <!-- 页面位置提示 -->
        <div class="ymessage">
          <el-breadcrumb separator=">">
            <el-breadcrumb-item :to="{ path: pathop }">{{ breadtitle }}</el-breadcrumb-item>
            <el-breadcrumb-item>资源详情</el-breadcrumb-item>
            <el-breadcrumb-item>{{ sucxinxi.material.title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 资源展示 -->
        <div class="filecenter clearfix">
          <div class="file_view" >
            <div class="file_loading" v-show="fileLoading">
              <img src="~@/assets/images/image.gif" width="300px" alt="">
            </div>
            <!-- 资源 -->
            <div
              class="file_detail img_box"
              v-if="
                ['jpg', 'png', 'JPEG', 'jpeg', 'GIF', 'gif'].includes(
                  sucxinxi.material.suffix
                )
              "
            >
              <img
                v-if="sucxinxi.material.coverUrl == null"
                src="~@/assets/images/login-background.jpg"
                alt=""
              />

              <img
                v-else
                :src="formatUrl(sucxinxi.material.resourceUrl)"
                @click="getImg(formatUrl(sucxinxi.material.resourceUrl))"
                alt=""
              />
            </div>
            <!-- 视频 -->
            <div class="file_detail" v-else-if="sucxinxi.material.suffix == 'mp4'">
              <div
                class="paly_warp"
                v-if="sucxinxi.material.coverUrl !== null && playshow == false"
              >
                <span @click="playvideo" class="icon_play"
                  ><i class="el-icon-video-play"></i
                ></span>
              </div>
              <img
                v-if="sucxinxi.material.coverUrl !== null && playshow == false"
                :src="formatUrl(sucxinxi.material.coverUrl)"
                alt=""
              />
              <video
                ref="vidref"
                id="video"
                v-if="sucxinxi.material.coverUrl == null || playshow == true"
                :src="formatUrl(sucxinxi.material.resourceUrl)"
                controls
                controlslist="nodownload"
              ></video>
            </div>
            <!-- 音频 mp3class-->
            <div
              class="file_detail"
              v-else-if="
                sucxinxi.material.suffix == 'mp3' || sucxinxi.material.suffix == 'ogg'
              "
            >
              <img
                v-if="sucxinxi.material.coverUrl == null"
                src="~@/assets/images/login-background.jpg"
                alt=""
              />
              <img v-else :src="formatUrl(sucxinxi.material.coverUrl)" alt="" />
              <audio
                :src="formatUrl(sucxinxi.material.resourceUrl)"
                controls
                controlslist="nodownload"
              >
                您的浏览器不支持 audio 标签。
              </audio>
            </div>
            <!-- 文档ppt等 -->
            <div
              class="file_detail"
              v-else-if="
                ['txt', 'doc', 'xlsx', 'xls', 'docx', 'ppt', 'pptx', 'pdf'].includes(
                  sucxinxi.material.suffix
                )
              "
            >
              <iframe @load="handleIframeload" :src="filehtml" frameborder="0" width="100%" height="100%"></iframe>
            </div>
            <div class="file_detail" v-else>
              <img
                :src="formatUrl(sucxinxi.material.coverUrl)"
                @click="getImg(formatUrl(sucxinxi.material.coverUrl))"
                alt=""
              />
            </div>
            <!-- 底部操作 -->
            <div class="botcaozuo">
              <div class="caozuo_left">
                <div class="list_icons" @click="fabuloubtns(0)">
                  <img
                    class="imgops"
                    v-if="sucxinxi.pros == 0"
                    src="~@/assets/images/zanouts.png"
                    alt=""
                  />
                  <img class="imgops" v-else src="~@/assets/images/fabulous.png" alt="" />
                  <span>{{ sucxinxi.material.pros }}</span>
                </div>
                <div class="list_icons" @click="fabuloubtns(1)">
                  <img
                    class="imgops"
                    v-if="sucxinxi.pros == 1"
                    src="~@/assets/images/caiouts.png"
                    alt=""
                  />
                  <img v-else class="imgops" src="~@/assets/images/cai.png" alt="" />
                  <span>{{ sucxinxi.material.cons }}</span>
                </div>
                <!-- <div class="list_icons" @click="collction">
                  <i
                    :class="
                      sucxinxi.collected == true
                        ? 'el-icon-star-on icolorb'
                        : 'el-icon-star-off icolora'
                    "
                  ></i>
                  <span>收藏</span>
                </div> -->
                <div class="list_icons" @click="copyurls">
                  <img class="imgops2" src="~@/assets/images/shart.png" alt="" />
                  <span>分享</span>
                </div>
              </div>

              <div class="caozuo_rig">
                <el-button
                  type="primary"
                  v-if="sucxinxi.material.allowDownload == true"
                  class="downloads"
                  icon="el-icon-download"
                  @click="downloadbtns(formatUrl(sucxinxi.material.resourceUrl),sucxinxi.material.originalName,sucxinxi.material.id)"
                  :loading="loading"
                  >下载
                </el-button>
                <a
                  class="yulblank"
                  v-if="
                    ['txt', 'doc', 'xlsx', 'xls', 'docx', 'ppt', 'pptx', 'pdf'].includes(
                      sucxinxi.material.suffix
                    )
                  "
                  :href="filehtml"
                  target="_blank"
                  rel="noopener noreferrer"
                  >全屏</a
                >

                <!-- <img
                  @click="jubaoshow = !jubaoshow"
                  slot="reference"
                  src="~@/assets/images/jubao.png"
                  alt=""
                /> -->
                <transition name="el-fade-in-linear">
                  <div class="jubaobtns" v-show="jubaoshow">
                    <el-button type="text" @click="jubaobtn">举报</el-button>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <!-- 介绍 -->
          <div class="rig_alls">
            <!-- 作品简介 -->
            <div class="file_rig_centersl">
              <div class="zpdataone">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="sucxinxi.material.title"
                  placement="top-start"
                >
                  <p class="name_textone">{{ sucxinxi.material.title }}</p>
                </el-tooltip>
                <p class="xian_btm"></p>
              </div>
            </div>
            <el-scrollbar class="files_scroll" style="height:440px;padding-bottom: 20px;">
              <div class="file_right">
                <!-- botm -->
                <div class="file_rig_btm">
                  <h3>素材信息</h3>
                  <p>
                    文件标题：
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="sucxinxi.material.title"
                      placement="top-start"
                    >
                      <span>{{ sucxinxi.material.title }}</span>
                    </el-tooltip>
                  </p>
                  <p v-for="(type, index) in sucxinxi.types" :key="index">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="type.typeSmalls"
                      placement="top-start"
                    >
                      <span> {{ type.typeBig }}：{{ type.typeSmalls || "" }}</span>
                    </el-tooltip>
                  </p>
                  <p>上传者：{{ sucxinxi.user.nickName }}</p>
                  <p>媒体类型：{{ sucxinxi.mediaType }}</p>
                  <!-- <p>原创类型：{{ sucxinxi.produceType }}</p> -->
                  <p>
                    关键字：
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="sucxinxi.material.tag"
                      placement="top-start"
                    >
                      <span>{{ sucxinxi.material.tag }}</span>
                    </el-tooltip>
                  </p>
                  <p>文件格式：{{ sucxinxi.material.suffix }}</p>
                  <p>文件大小：{{ sucxinxi.material.fileSize | calSize }}</p>
                  <p>发布时间：{{ sucxinxi.material.createTime.substr(0, 10) }}</p>
                  <p
                    v-for="(itemv, keyv) in mediaInfo"
                    :key="keyv + 'o'"
                    class="txtp2 txtcolors txt-line1"
                  >
                    {{ itemv.name }}:{{ itemv.value }}
                  </p>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <!-- 举报弹框 -->
    <el-dialog title="举报" :visible.sync="dialogjubao" width="500px" center>
      <div class="jubaowarp">
        <div class="checkalls">
          <el-checkbox-group v-model="checkList" @change="changecheck">
            <div style="margin-top: 20px">
              <el-checkbox label="涉嫌侵权"></el-checkbox>
              <el-checkbox label="低俗信息"></el-checkbox>
              <el-checkbox label="垃圾广告信息"></el-checkbox>
            </div>
            <div style="margin-top: 20px">
              <el-checkbox label="不良封面/标题"></el-checkbox>
              <el-checkbox label="涉黄涉暴等违法行为"></el-checkbox>
              <el-checkbox label="青少年不良信息"></el-checkbox>
            </div>
            <div style="margin-top: 20px">
              <el-checkbox label="侮辱恶意及辱骂行为"></el-checkbox>
              <el-checkbox label="人身攻击"></el-checkbox>
              <el-checkbox label="虚假信息"></el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="supplement">
          <p>请补充举报问题</p>
          <el-input
            type="textarea"
            :rows="6"
            resize="none"
            placeholder="请输入内容"
            v-model="textarea"
          >
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogjubao = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="reportall">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 相关推荐 -->
    <div class="file_listall">
      <div class="file_list inner">
        <div class="file_listtuij">
          <p>
            <span class="Line_tj"></span> <span class="tj_title">相关推荐</span>
            <span class="Line_tj"></span>
          </p>
        </div>
        <div class="emptyall" v-if="filelist.length == 0">
          <el-empty description="暂无相关资源推荐"></el-empty>
        </div>
        <!-- 资源列表 -->
        <div class="modelist" v-else>
          <metail-item :metailList="filelist"></metail-item>
          <!-- <div
            class="achie_model"
            v-for="(item, index) in filelist"
            :key="index"
            @click="goDetail(item)"
          >
            <div class="achie_tops">
              <el-image
                v-if="item.content.material.coverUrl !== null"
                :src="formatUrl(item.content.material.coverUrl)"
                fit="cover"
              >
              </el-image>
              <el-image
                v-if="
                  item.content.material.coverUrl == null &&
                  item.content.material.suffix == 'mp3'
                "
                :src="mpimg3"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <el-image
                v-if="
                  item.content.material.coverUrl == null &&
                  ['pdf', 'txt', 'doc', 'xlsx', 'xls', 'docx', 'ppt', 'pptx'].includes(
                    item.content.material.suffix
                  )
                "
                :src="txtimg"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <el-image
                style="height: 192px; width: 100%"
                v-if="
                  item.content.material.coverUrl == null &&
                  item.content.material.suffix == null
                "
                :src="mrimgs"
                fit="cover"
              >
              </el-image>
            </div>
            <div class="achie_text">
              <div class="achiebotms">
                <p class="txtp1 pcont txt-line1">{{ item.content.material.title }}</p>
                <p class="txtp2 txt-line1">
                  <i class="el-icon-view"></i>
                  {{ item.content.material.clicks }}
                </p>
              </div>
              <div class="achie_sp">
                <p class="txtp1 txtcolors txt-line1">
                  文件格式：{{ item.content.material.suffix }}
                </p>
                <p class="txtp2 txtcolors txt-line1">
                  文件大小：{{ item.content.material.fileSize | calSize() }}
                </p>
              </div>
              <div class="achie_sp">
                <p class="txtp3 txtcolors txt-line1">
                  发布时间：{{ item.content.material.createTime.substr(0, 10) }}
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 预览图片组件 -->
    <el-image-viewer
      v-if="payVoucherDialog"
      :on-close="closeViewer"
      :url-list="imageSrcLists"
      :z-index="20000"
    />
    <el-dialog
      title="登 录"
      :visible.sync="dialoglogin"
      width="500px"
      :close-on-click-modal="false"
      custom-class="dialogins"
      :before-close="handleClose"
    >
      <!-- <loginview ref="loginoff" @digshow="digshow"></loginview> -->
    </el-dialog>
  </div>
</template>
<script>
import { calSize } from "@/utils";
// 大图预览
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import metailItem from "@/components/metailItem/index.vue";
import {
  getLibraryDetails,
  queryES,
  getPros,
  setCollect,
  setReport,
  getDownload,
  yulanUrl,
  addDownbtn,
} from "@/api/library";
import {getdownload} from "@/utils/request";
export default {
  name: "LibraryDetails",
  data() {
    return {
      materialId: null,
      sucxinxi: {
        collected: "", //收藏状态
        pros: "", //0点赞 1反对
        material: {
          title: "",
          pros: "",
          cons: "",
          description: "",
          mediaType: "",
          produceType: "",
          suffix: "",
          fileSize: "",
          createTime: "",
          coverUrl: "",
        },
        user: {
          nickName: "",
          updates: "",
          avatar: "",
        },
        types: [],
        mediaType: "",
      },
      filelist: [
        {
          content: {
            material: {
              title: "",
              clicks: "",
              suffix: "",
              fileSize: "",
              createTime: "",
              coverUrl: "",
            },
          },
          id: "",
        },
      ],
      jubaoshow: false,
      baseurl: process.env.VUE_APP_BASE_API,
      divloading: false, //防止重复点击
      dialogjubao: false, //举报弹出框
      checkList: [],
      textarea: "", //举报补充的信息
      loading: false,
      dialoglogin: false, //登陆
      mrimgs: require("../assets/images/banner.png"),
      mpimg3: require("../assets/images/mp3img.png"),
      txtimg: require("../assets/images/textimg.png"),
      filehtml: "", //文件地址
      mediaInfo: [], //文件的额外信息
      playshow: false, //视频显示
      payVoucherDialog: false, //预览flag
      imageSrcLists: [], //预览数组
      // 面包屑
      pathop: "/", //路由地址
      breadtitle: "首页",
      fileLoading:false
    };
  },
  components: {
    // loginview,
    ElImageViewer,
    metailItem,
  },
  filters: {
    calSize(fileSize) {
      return calSize(fileSize);
    },
  },
  watch: {
    "$store.state.userdata": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (newValue !== null) {
          //登录后请求资源详情内的收藏 点赞等
          this.filedetailsg();
        }
      },
    },
  },
  created() {
    this.yulget();
    this.materialId = this.$route.query.id;
    this.breadtitle = this.$route.query.title;
    if (this.$route.query.tabindex.indexOf(0) > -1) {
      this.$store.commit("user/SET_TABINDEX", this.$route.query.tabindex);
    } else {
      this.$store.commit("user/SET_TABINDEX", Number(this.$route.query.tabindex));
    }

    switch (this.breadtitle) {
      case "收藏":
        this.pathop = "/profile-core/collect";
        break;
      case "我的作品":
        this.pathop = "/profile-core/works";
        break;
      case "作品审核":
        this.pathop = "/profile-core/examine";
        break;
      default:
        break;
    }
    //详情内容
    this.filedetailsg();
  },
  mounted() {},
  methods: {
    //预览地址请求
    yulget() {
      yulanUrl().then((res) => {
        this.$previewurl = res.msg;
      });
    },
    formatUrl(url) {
      var str = new RegExp("http");
      if (str.test(url)) {
        return url;
      } else {
        return url == null
          ? url
          : url.startsWith("/profile")
          ? this.baseurl + url
          : this.baseurl + "/profile/" + url;
      }
    },
    goDetail(item) {
      this.materialId = item.id;

      let rourl = this.$router.resolve({
        path: "/library-details",
        query: {
          id: this.materialId,
          title: "资源列表",
          tabindex: this.$store.state.user.tabindex,
        },
      });
      window.open(rourl.href);
    },
    // 详情
    filedetailsg() {
      getLibraryDetails({
        materialId: this.materialId,
        userId: this.$store.getters.userId,
      }).then((res) => {
        if (res.code == 200) {
          this.sucxinxi = res.data;
          // 文件的额外信息
          this.mediaInfo = JSON.parse(this.sucxinxi.material.mediaInfo);
          // 相关推荐
          this.recommend(this.sucxinxi.material.tag, this.sucxinxi.types);
          //预览
          this.yulan();
          if(['txt', 'doc', 'xlsx', 'xls', 'docx', 'ppt', 'pptx', 'pdf'].includes(this.sucxinxi.material.suffix)){
            this.fileLoading = true
          }
        }
      });
    },
    handleIframeload(){
      this.fileLoading = false
    },
    // 相关推荐
    recommend(keywords, types) {
      var newObjs = {};
      for (let i = 0; i < types.length; i++) {
        if (types[i].typeBigId == 2 || types[i].typeBigId == 3 || types[i].typeBigId == 4)
          newObjs["big" + types[i].typeBigId] = types[i].typeSmallId;
      }
      let datas = {
        keywords: keywords,
        status: 2,
        types: newObjs,
      };
      queryES(datas, { size: 8, page: 1 }).then((res) => {
        if (res.code == 200) {
          this.filelist = res.rows;
        }
      });
    },
    // 点赞/反对
    fabuloubtns(operate) {
      if (this.$store.getters.token == null) {
        this.$message({
          message: "请先登陆再进行操作",
          type: "warning",
          offset: 150,
        });
        setTimeout(() => {
          var that = this;
          this.$login({
            loginSuccess() {
              that.$router.push({
                path: "/redirect" + that.$route.fullPath,
              });
            },
          });
        }, 1000);
        return;
      }
      if (this.divloading == false) {
        let formdata = new FormData();
        formdata.append("materialId", Number(this.materialId));
        formdata.append("operate", operate);

        // this.$http.post("/business/material/pros", formdata).
        getPros(formdata).then((res) => {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.divloading = true;
          setTimeout(() => {
            this.divloading = false;
          }, 600);
          this.filedetailsg();
        });
      }
    },
    //收藏
    collction() {
      if (this.$store.getters.token == null) {
        this.$message({
          message: "请先登陆再进行操作",
          type: "warning",
        });
        setTimeout(() => {
          var that = this;
          this.$login({
            loginSuccess() {
              that.$router.push({
                path: "/redirect" + that.$route.fullPath,
              });
            },
          });
        }, 1000);
        return;
      }
      if (this.divloading == false) {
        let datas = {
          collectBy: this.$store.getters.userId, //收藏人ID
          materialId: this.materialId,
        };
        // this.$http.post("/business/collect", datas)
        setCollect(datas).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
          this.divloading = true;
          setTimeout(() => {
            this.divloading = false;
          }, 600);
          this.filedetailsg();
        });
      }
    },
    // 查询用户信息
    userdata() {
      this.$http.get("/system/user/myDetail").then((res) => {
        if (res.code == 200) {
          let usdata = JSON.stringify(res.data);
          localStorage.setItem("userdata", usdata);
          if (localStorage.getItem("userdata")) {
            this.$store.commit("userdata", JSON.parse(localStorage.getItem("userdata")));
          }
        }
      });
    },
    // 举报
    jubaobtn() {
      if (this.$store.getters.token == null) {
        this.$message({
          message: "请先登陆再进行操作",
          type: "warning",
        });
        setTimeout(() => {
          var that = this;
          this.$login({
            loginSuccess() {
              that.$router.push({
                path: "/redirect" + that.$route.fullPath,
              });
            },
          });
        }, 1000);
        return;
      }
      this.checkList = [];
      this.textarea = "";
      this.dialogjubao = true;
    },
    // 多选
    changecheck(val) {
      console.log(val, "val");
    },
    //提交举报信息
    reportall() {
      if (this.textarea == "" || this.checkList.length == 0) {
        this.$message({
          message: "请补充举报原因",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      let txtjub = this.checkList.toString() + "---" + this.textarea;

      let datas = {
        meterialId: this.sucxinxi.material.id, //被举报资源id
        meterialName: this.sucxinxi.material.title, //资源名称
        content: txtjub,
        createId: this.$store.getters.userId, //举报人ID
      };
      //   this.$http.post("/business/report/", datas)
      setReport(datas).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.dialogjubao = false;
        }
        //防重复点击
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    //子组件传值
    digshow(val) {
      this.dialoglogin = val;
      this.handleClose();
    },
    //关闭登陆
    handleClose() {
      this.dialoglogin = false;
    },

    // 下载
    downloadbtns(fileUrl,fileName,fileId) {
      if (this.$store.getters.token == null) {
        this.$message({
          message: "请先登录再进行操作",
          type: "warning",
        });
        setTimeout(() => {
          var that = this;
          this.$login({
            loginSuccess() {
              that.$router.push({
                path: "/redirect" + that.$route.fullPath,
              });
            },
          });
        }, 1000);
        return;
      }
      this.loading = true
      getdownload('business/material/getFile',{fileId},fileName).finally(()=>{
        this.loading = false
      });
      let datas = { id: this.sucxinxi.material.id };
      addDownbtn(datas).then((res) => {});
    },
    //下载资源
    download(src, filenamep) {
      fetch(src)
        .then((res) => res.blob())
        .then((blob) => {
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style.display = "none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = filenamep;
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        });
    },
    // 预览文档格式资源
    base64encode(str) {
      var base64EncodeChars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var out, i, len;
      var c1, c2, c3;
      len = str.length;
      i = 0;
      out = "";
      while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt((c1 & 0x3) << 4);
          out += "==";
          break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
          out += base64EncodeChars.charAt((c2 & 0xf) << 2);
          out += "=";
          break;
        }
        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3f);
      }
      return out;
    },
    yulan() {
      let urlas = window.location.href.split("/#/")[0];
      let fileurl = "";
      if (
        this.sucxinxi.material.resourceUrl.indexOf("http") > -1 ||
        this.sucxinxi.material.resourceUrl.indexOf("https") > -1
      ) {
        fileurl = this.sucxinxi.material.resourceUrl;
      } else {
        fileurl = urlas + this.baseurl + "/profile/" + this.sucxinxi.material.resourceUrl;
      }
      console.log(fileurl, "fileurl");
      let openurl =
        this.$previewurl + "?url=" + encodeURIComponent(this.base64encode(fileurl));
      this.filehtml = openurl;
    },
    // 播放
    playvideo() {
      this.playshow = true;
      setTimeout(() => {
        this.$refs.vidref.play();
      }, 500);
    },
    // 分享
    copyurls() {
      let copyurl = window.location.href;
      this.CVcopy(copyurl);
    },
    // 复制文本
    CVcopy(data) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", data);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("资源链接复制成功");
      } else {
        this.$message.error("资源链接复制失败");
      }
      document.body.removeChild(input);
    },
    // 关闭图片预览
    closeViewer() {
      this.payVoucherDialog = false;
      document.documentElement.style.overflowY = "auto";
    },
    // 获取图片的url
    getImg(url) {
      if (url) {
        this.imageSrcLists = [url];
        this.payVoucherDialog = true;
        document.documentElement.style.overflowY = "hidden";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filedetails {
  width: 100%;
  overflow: hidden;
  .filedeta_centers {
    background: #f7f8fa;
    padding: 20px 0;
  }
  // 页面位置提示
  .ymessage {
    margin: 20px auto;
    font-size: 18px;
    // padding: 0 20px;
  }

  .filecenter {
    // width: 1240px;
    // width: 1476px;
    margin: 0 auto;
    // padding: 0 20px;
    // height: 600px;
    .file_view {
      width: calc(100% - 400px);
      float: left;
      padding-right: 10px;
      position: relative;
      .file_loading{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 6;
        background-color: #fff;
      }
      .mp3class {
        background: url("~@/assets/images/login-background.jpg") no-repeat;
        background-size: 100% 100%;
      }

      .file_detail {
        width: 100%;
        height: 445px;
        position: relative;
        background-color: #fff;
        &.img_box {
          background: #666;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            cursor: pointer;
            height: auto;
            width: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }

        img,
        video {
          width: 100%;
          height: 100%;
          background-color: #333;
        }

        audio {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        .paly_warp {
          width: 100%;
          height: 100%;
          background: #000000;
          opacity: 0.25;
          position: absolute;
          z-index: 90;

          .icon_play {
            position: absolute;
            left: 50%;
            top: 50%;
            font-size: 70px;
            color: #fff;
            transform: translate(-50%, -50%);
            cursor: pointer;
          }
        }
      }

      // 底部操作
      .botcaozuo {
        width: 100%;
        height: 49px;
        // background-color: #fff;

        .caozuo_left {
          width: 350px;
          display: flex;
          justify-content: space-around;
          margin-top: 4px;
          cursor: pointer;

          float: left;

          .list_icons {
            height: 50px;
            display: flex;
            line-height: 46px;

            i {
              font-size: 24px;
              margin-top: 9px;
            }

            .icolora {
              color: #999999;
            }

            .icolorb {
              color: #2d6afe;
            }

            .imgops {
              width: 22px;
              height: 20px;
              margin-top: 12px;
            }
            .imgops2 {
              width: 17px;
              height: 20px;
              margin-top: 12px;
            }
            span {
              margin-left: 5px;
            }
          }
        }

        // 下载和举报
        .caozuo_rig {
          float: right;
          margin-top: 10px;
          cursor: pointer;
          position: relative;

          .downloads {
            width: 80px;
            height: 28px;
            background-color: #2e5cce;
            border: #2e5cce;
            font-size: 14px;
            padding: 1px !important;
            float: left;
            margin: 0 10px;
          }
          .yulblank {
            display: inline-block;
            height: 28px;
            width: 80px;
            padding: 0;
            line-height: 28px;
            font-size: 14px;
            text-align: center;
            background: #fec650;
            color: #fff;
            border-radius: 4px;
            margin-right: 20px;
          }
          img {
            width: 24px;
            height: 24px;
            float: right;
            margin: 3px 10px;
          }

          .jubaobtns {
            position: absolute;
            bottom: -50px;
            right: 0px;
            background-color: #fff;
            width: 60px;
            height: 40px;
            text-align: center;
            border-radius: 10px;
            font-size: 16px;
            z-index: 99;
          }
        }
      }
    }
    .rig_alls {
      width: 400px;

      float: right;
      overflow: hidden;
      padding-left: 10px;
      // border: 1px solid red;
      // 作品简介
      .file_rig_centersl {
        width: 100%;
        height: 72px;

        .zpdataone {
          width: 100%;
          height: 72px;
          margin: 0 auto;

          .name_textone {
            font-size: 18px;
            font-weight: bolder;
            color: #242424;
            letter-spacing: 2px;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .xian_btm {
            width: 30px;
            height: 4px;
            margin-top: 10px;
            background-color: #f78919;
          }
        }
      }
    }
    .files_scroll {
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden !important;
      }
    }
    .file_right {
      width: 100%;
      // height: 440px;
      float: right;
      

      // 上传者信息
      .file_rig_top {
        width: 100%;
        height: 115px;
        padding: 0 30px;

        h3 {
          border-bottom: 1px solid #999999;
          padding-bottom: 15px;
        }

        .zpdata {
          width: 100%;
          margin-top: 10px;
          display: flex;

          img {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            margin-top: 10px;
          }

          .name_nums {
            margin-left: 10px;

            .name_text {
              margin-top: 6px;
              font-size: 14px;
              letter-spacing: 2px;
            }

            .num_text {
              margin-top: 10px;
              font-size: 14px;
              white-space: nowrap;
              font-weight: 400;
              color: #999999;

              .jifenops {
                display: inline-block;
                margin-left: 10px;
              }
            }
          }
        }
      }

      // 素材信息
      .file_rig_btm {
        float: left;
        width: 100%;
        background-color: #fff;
        padding: 30px 30px 0 30px;

        h3 {
          border-bottom: 1px solid #eeeeee;
          padding-bottom: 15px;
        }

        p {
          width: 85%;
          height: 30px;
          line-height: 30px;
          margin: 5px 0 0 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #999999;
        }
      }
    }
  }

  // 相关推荐
  /* 空数据时 */
  .emptyall {
    width: 100%;
    height: 300px;
    text-align: center;
  }

  .file_listall {
    width: 100%;
    background-color: #fff;

    .file_list {
      margin: 20px auto;
      padding-bottom: 30px;

      .file_listtuij {
        width: 100%;
        text-align: center;
        padding: 30px 0 10px 0;

        .tj_title {
          font-size: 30px;
          font-weight: bold;
          color: #f78919;
        }
        .Line_tj {
          display: inline-block;
          width: 20px;
          height: 3px;
          background-color: #f78919;
          margin: 6px 18px;
        }
      }

      /* 资源列表 */
      .modelist {
        margin-top: 30px;
      }

      .achie_model {
        width: 280px;
        height: 286px;
        border-radius: 10px;
        background-color: #fff;
        overflow: hidden;
        cursor: pointer;
        margin: 25px 0 0 20px;
        transition: all 0.4s;
        border: 1px solid #eeeeee;
      }

      .achie_tops {
        height: 158px;
        border-radius: 3px;
        overflow: hidden;
      }

      .achie_model:hover {
        box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
      }

      .achie_model:hover img {
        transform: scale(1.2);
      }

      .achie_tops > .el-image {
        width: 100%;
        height: 100%;
        transition: all 0.4s;
      }

      /* 介绍 */
      .achie_text {
        width: 100%;
        font-size: 14px;
        color: gray;
      }

      .achiebotms {
        height: 49px;
        line-height: 25px;
        padding: 15px 10px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        border-bottom: 1px solid #f2f2f2;
      }
      .pcont {
        font-size: 18px;
        color: #181818;
      }
      .achie_sp {
        width: 100%;
        height: 30px;
        padding: 6px 10px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
      }

      .txtp1,
      .txtp2 {
        height: 25px;
      }

      .txtp1 {
        width: 60%;
        text-align: left;
      }

      .txtp2 {
        width: 40%;
        text-align: right;
      }

      .txtp3 {
        width: 100%;
        height: 25px;
      }

      .txtcolors {
        color: #b3b3b3;
      }
    }
  }

  // 举报弹出框
  .jubaowarp {
    width: 100%;

    .checkalls {
      width: 100%;
      margin-top: 20px;
    }

    .supplement {
      margin-top: 30px;

      p {
        font-size: 16px;
        padding: 20px 0;
      }
    }
  }
}
</style>
<style lang="scss">
.modelist {
  .metailItemwarp {
    .achie_model {
      .achie_model_inner {
        border: 1px solid #eeeeee;
      }
    }
  }
}
</style>
